import * as Yup from 'yup'

const FieldConfigs = [{
  name: 'oldPassword',
  label: 'Current Password',
  autoFocus: true,
  placeholder: 'Enter your current password',
  type: 'password'
},{
  name: 'newPassword',
  label: 'Password',
  placeholder: 'Enter password',
  type: 'password'
}, {
  name: 'rePassword',
  label: 'Re Password',
  placeholder: 'Enter password',
  type: 'password'
}]


const ValidationSchema = Yup.object().shape({
    oldPassword: Yup.string().required('Enter your current password'),
    newPassword: Yup.string().required('Enter your new password'),
    rePassword: Yup.string().required('Enter your password again').oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})


export  {FieldConfigs, ValidationSchema};
